import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Modal simple para ver una imagen en grande (p. ej. la foto de perfil, para verificarla).
 * Estilo monocromo OTRIX.
 */
function ImageViewModal({ open, src = null, alt = 'Imagen', onClose }) {
  if (!src) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, backgroundColor: 'surface.content', backgroundImage: 'none', border: '1px solid', borderColor: 'hairline.main', position: 'relative' } }}
    >
      <IconButton onClick={onClose} aria-label="cerrar" sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary', zIndex: 1, '&:hover': { color: 'text.primary', backgroundColor: 'rgba(255,255,255,0.08)' } }}>
        <CloseIcon />
      </IconButton>
      <Box sx={{ p: { xs: 3, sm: 4 }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{ width: '100%', maxWidth: 360, maxHeight: '70vh', objectFit: 'contain', borderRadius: 2 }}
        />
      </Box>
    </Dialog>
  );
}

ImageViewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  src: PropTypes.string,
  alt: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default ImageViewModal;
